"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductPrice = void 0;
var _react = _interopRequireDefault(require("react"));
var _enums = require("../../constants/enums");
var _wbmFormatMoney = require("wbm-format-money");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var ProductPrice = exports.ProductPrice = function ProductPrice(_ref) {
  var _unitPriceByIndUnit, _props$lineLevelCoupo;
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var salesPrice = /*#__PURE__*/_react["default"].createElement(_wbmFormatMoney.WBMFormatMoney, {
    amount: props.salesPrice,
    useCurrencySign: true
  });
  var unitPrice = /*#__PURE__*/_react["default"].createElement(_wbmFormatMoney.WBMFormatMoney, {
    amount: props.unitPrice,
    useCurrencySign: true
  });
  var listPrice = /*#__PURE__*/_react["default"].createElement(_wbmFormatMoney.WBMFormatMoney, {
    amount: props.listPrice,
    useCurrencySign: true,
    className: "list-price"
  });
  var unitPriceByIndUnit = 0;
  if (props.individualUnitData) {
    unitPriceByIndUnit = props.unitPrice / props.individualUnitData.indivUnitCount;
  }
  var unitPriceByIndUnitFormatted = /*#__PURE__*/_react["default"].createElement(_wbmFormatMoney.WBMFormatMoney, {
    amount: Number((_unitPriceByIndUnit = unitPriceByIndUnit) === null || _unitPriceByIndUnit === void 0 ? void 0 : _unitPriceByIndUnit.toFixed(2)),
    useCurrencySign: true
  });
  var lineLevelCouponSavings = /*#__PURE__*/_react["default"].createElement(_wbmFormatMoney.WBMFormatMoney, {
    amount: ((_props$lineLevelCoupo = props.lineLevelCouponSavings) === null || _props$lineLevelCoupo === void 0 ? void 0 : _props$lineLevelCoupo.savings) || 0,
    useCurrencySign: true
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: props.displayListPrice ? "wbm-product-pricing display-list-price" : "wbm-product-pricing"
  }, /*#__PURE__*/_react["default"].createElement("div", null, props.asLowAs && /*#__PURE__*/_react["default"].createElement("span", {
    className: "small-text"
  }, "As low as "), props.aboveSalesUnitPrice && props.individualUnitData && /*#__PURE__*/_react["default"].createElement("div", {
    className: "small-text"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "unit-price mb-0"
  }, " ", unitPriceByIndUnitFormatted), /*#__PURE__*/_react["default"].createElement("span", {
    className: "unit-id spacing"
  }, "/", props.individualUnitData.indivUnitLabel)), props.lineLevelCouponSavings ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "price-row"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "original-price"
  }, props.salesPrice ? salesPrice : ''), /*#__PURE__*/_react["default"].createElement("span", {
    className: "discounted-price"
  }, props.unitPrice ? unitPrice : ''), props.oncePerCustomer && /*#__PURE__*/_react["default"].createElement("span", {
    className: "footnote-indicator"
  }, "\u2170"), props.qtyLimit > 0 && /*#__PURE__*/_react["default"].createElement("span", {
    className: "footnote-indicator"
  }, "\u2171"), /*#__PURE__*/_react["default"].createElement("span", {
    className: "unit-id"
  }, "/", props.unitId), /*#__PURE__*/_react["default"].createElement("span", {
    className: "discount"
  }, props.lineLevelCouponDisplayType == _enums.LineLevelCouponDiscDisplay.Percent ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "(", props.lineLevelCouponSavings.savings, "% Savings!)") : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "(Save ", lineLevelCouponSavings, ")")), props.belowSalesUnitPrice && props.individualUnitData && /*#__PURE__*/_react["default"].createElement("div", {
    className: "small-text"
  }, unitPriceByIndUnitFormatted, /*#__PURE__*/_react["default"].createElement("span", {
    className: "unit-id spacing"
  }, "/", props.individualUnitData.indivUnitLabel))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "price-row"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: props.aboveSalesUnitPrice && props.individualUnitData ? '' : 'unit-price'
  }, props.unitPrice ? unitPrice : '$0.00'), props.oncePerCustomer && /*#__PURE__*/_react["default"].createElement("span", {
    className: "footnote-indicator"
  }, "\u2170"), props.qtyLimit > 0 && /*#__PURE__*/_react["default"].createElement("span", {
    className: "footnote-indicator"
  }, "\u2171"), /*#__PURE__*/_react["default"].createElement("span", {
    className: "unit-id"
  }, "/", props.unitId)), props.belowSalesUnitPrice && props.individualUnitData && /*#__PURE__*/_react["default"].createElement("div", {
    className: "small-text"
  }, unitPriceByIndUnitFormatted, /*#__PURE__*/_react["default"].createElement("span", {
    className: "unit-id spacing"
  }, "/", props.individualUnitData.indivUnitLabel)))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row no-gutters"
  }, props.displayUnitPricing && props.individualUnitData && props.individualUnitData.indivUnitCount !== 0 && !props.aboveSalesUnitPrice && !props.belowSalesUnitPrice && /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "small-text"
  }, unitPriceByIndUnitFormatted, " ", /*#__PURE__*/_react["default"].createElement("span", {
    className: "unit-id spacing"
  }, "/", props.individualUnitData.indivUnitLabel))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-auto"
  }, props.qtyBreaks)), props.displayFootnotes && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.oncePerCustomer && /*#__PURE__*/_react["default"].createElement("div", {
    className: "footnote d-flex"
  }, "\u2170 ", props.couponCustomerLimitMessage), props.qtyLimit > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "footnote d-flex"
  }, "\u2171 ", props.couponQtyLimitMessage.replace("[LimitQuantity]", props.qtyLimit.toString()))), props.displayListPrice && /*#__PURE__*/_react["default"].createElement("div", {
    className: "list-price-container d-flex"
  }, "List: ", props.listPrice ? listPrice : '$', " ", /*#__PURE__*/_react["default"].createElement("span", {
    className: "unit-id"
  }, "/", props.unitId)));
};
ProductPrice.defaultProps = {
  couponCustomerLimitMessage: "Discount valid for 1 order per account",
  couponQtyLimitMessage: "Discount valid on orders of [LimitQuantity] or less.",
  displayFootnotes: true,
  qtyLimit: 0
};
//# sourceMappingURL=productPrice.js.map